import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { getIntensityLabel, getIntensityLevel, INTENSITY_LEVELS } from '../../utils/chartIntensity';

import './IntensityMeter.scss';

// Five rising bars, as many lit as the level
const IntensityMeter = ({ level, className = '' }) => {
  const { t } = useTranslation();
  const { id } = getIntensityLevel(level);

  return (
    <span
      className={cx('IntensityMeter', className)}
      role="img"
      aria-label={t('intensity.meter', { level: getIntensityLabel(id) })}
    >
      {INTENSITY_LEVELS.map((step) => (
        <span key={step.id} className={cx('bar', { lit: step.id <= id })} />
      ))}
    </span>
  );
};

IntensityMeter.propTypes = {
  level: PropTypes.number,
  className: PropTypes.string,
};

export default IntensityMeter;
